var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper_404"}},[_c('b-img',{staticClass:"align-self-center",attrs:{"src":require("@/assets/404.png"),"fluid":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }